import { useSubscription } from "@/lib/subscription";
import { useI18n } from "@/lib/i18n";
import { Sparkles, ArrowRight, Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { resetDemoAck } from "./AccessGate";

/**
 * Shown at the top of the dashboard whenever the signed-in user has no
 * active subscription/trial and is browsing the demo (2 pairs) mode.
 */
export default function DemoBanner() {
  const { has_access, demo_pairs, loading } = useSubscription();
  const { t, dir } = useI18n();
  const navigate = useNavigate();
  if (loading || has_access) return null;
  const pairs = demo_pairs || ["EUR/USD", "BTC/USDT"];
  return (
    <div
      data-testid="demo-banner"
      dir={dir}
      className="w-full bg-gradient-to-r from-emerald-500/10 via-amber-500/10 to-emerald-500/10 border-b border-emerald-500/30"
    >
      <div className="max-w-7xl mx-auto px-6 py-2.5 flex items-center gap-3 flex-wrap">
        <Lock className="w-4 h-4 text-amber-300 shrink-0" />
        <div className="text-sm text-zinc-200 flex-1 min-w-0">
          <span className="font-semibold">{t("demo_mode_title") || "Demo mode"}</span>
          <span className="text-zinc-400 mx-2">·</span>
          <span className="text-zinc-400">
            {t("demo_showing_only") || "Showing"}
            {" "}
            <span dir="ltr" className="font-mono text-emerald-300">{pairs.join(" + ")}</span>
            {". "}
            {t("demo_unlock_all") || "Unlock all 21 pairs with a plan."}
          </span>
        </div>
        <button
          data-testid="demo-upgrade-btn"
          onClick={() => { resetDemoAck(); navigate("/pricing"); }}
          className="inline-flex items-center gap-1.5 h-8 px-4 rounded-full bg-emerald-500 hover:bg-emerald-400 text-black text-xs font-bold transition"
        >
          <Sparkles className="w-3.5 h-3.5" />
          {t("upgrade_now") || "Upgrade now"}
          <ArrowRight className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
